import React, { useState } from "react";
import "./approveclaim.css";
import "./dashboard_right.css";

const hexToRgb = (hex) => {
  let bigint = parseInt(hex.slice(1), 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;
  return `${r}, ${g}, ${b}`;
};

const DashboardWithOverviewAndClaims = () => {
  const [activeTab, setActiveTab] = useState("stage");
  const [search, setSearch] = useState("");

  // Data for Stage-wise and Summary-wise views
  const stageData = [
    { label: "Claim Intimated", value: 4898, color: "#2D5EFF" },
    { label: "Surveyor Appointed", value: 2345, color: "#A87932" },
    { label: "Survey Completed", value: 4235, color: "#1DC690" },
    { label: "Work Approved", value: 450, color: "#7B6BFF" },
    { label: "Under Repair/ Inspection", value: 7289, color: "#22DDE8" },
    { label: "Re-Inspection", value: 272, color: "#D22A2A" },
    { label: "Pre-Invoice / Invoice", value: 450, color: "#4DC7E8" },
    { label: "Delivery Order", value: 2345, color: "#A87932" },
    { label: "Payment", value: 4235, color: "#1DC690" },
  ];

  const summaryData = [
    { label: "Total Claims Received", value: 4898, color: "#2D5EFF" },
    { label: "Total Claims Closed", value: 2345, color: "#A87932" },
    { label: "Total Open Claims", value: 4235, color: "#1DC690" },
  ];

  const activeData = activeTab === "stage" ? stageData : summaryData;
  const maxValue = Math.max(...activeData.map((item) => item.value));

  // Approved claims data
  const initialApprovedClaims = Array.from({ length: 9 }, (_, index) => ({
    id: `FM490${40 + index}`,
    status: "Approved",
  }));

  const filteredClaims = initialApprovedClaims.filter((claim) =>
    claim.id.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="dashboard-main">
      {/* Stage-wise Overview Section */}
      <div className="stage-wise-overview">
        <div className="overview-header">
          <span
            className={activeTab === "stage" ? "active-tab" : "inactive-tab"}
            onClick={() => setActiveTab("stage")}
          >
            Stage-wise Overview
          </span>
          <span
            className={activeTab === "summary" ? "active-tab" : "inactive-tab"}
            onClick={() => setActiveTab("summary")}
          >
            Summary-wise Overview
          </span>
        </div>

        <div className="top-section">
          <div className="claimss-box">
            <h2>57</h2>
            <p>Claims Opened Today</p>
          </div>
          <p className="date-range">Sep 12 - 15 • Light Vehicle</p>
        </div>

        <div className="filters">
          <select><option>Date</option></select>
          <select><option>Organization</option></select>
          <select><option>Surveyor Name</option></select>
          <select><option>Claim Owner</option></select>
          <select><option>Vehicle Type</option></select>
          <select className="full-width"><option>Claim Type</option></select>
        </div>

        <div className="status-list">
          {activeData.map((item, index) => (
            <div key={index} className="status-item">
              <div className="progress-container progress-container-secondry">
                <div
                  className="progresss-bar"
                  style={{
                    width: `${(item.value / maxValue) * 100}%`,
                    "--bar-color": item.color,
                    "--rgb-bar-color": hexToRgb(item.color),
                  }}
                ></div>
                <span className="status-value">{item.value}</span>
              </div>
              <span className="status-label">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

{/* Approved Claims Section here */}
<div className="completed-claims-card">
  <h2>All Completed Claims</h2>
  <div className="completed-claims-container">
    {filteredClaims.length > 0 ? (
      filteredClaims.slice(0, 3).map((claim, index) => (
        <div
          className={`completed-claim-box ${index === 2 ? 'faded-card' : ''}`}
          key={index}
        >
          <div className="completed-claim-info">
            <p className="claim-id">Claim {claim.id}</p>
            <p className="claim-status">
              <span className="double-green-tick">✔</span> Approved
            </p>
          </div>
          <button className="preview-button"> Preview</button>
        </div>
      ))
    ) : (
      <p className="no-results">No matching approved claims found.</p>
    )}
  </div>
  <button
    className="view-all-btn-right"
    onClick={() => window.location.href = '/claims'}
  >
    All Completed Claims
  </button>
</div>
    </div>
  );
};

export default DashboardWithOverviewAndClaims;
